<script>
    import { graphIndicatorPeriodEnum } from "../../../Utils/utilConstants.svelte";

    export let selectedPeriod = 0;
    export let onPeriodChange = () => {};

    const defaultIndicatorClass =
        "cursor-pointer w-24 text-center p-2 hover:bg-gray-200 hover:font-bold";

    const handlePeriodChange = (period = 0) => {
        selectedPeriod = period;

        onPeriodChange();
    };
</script>

<div class="flex w-fit border rounded rounded-lg m-2">
    <p
        class={`${defaultIndicatorClass} ${selectedPeriod === graphIndicatorPeriodEnum.daily ? "bg-gray-200 font-bold" : ""}`}
        on:click|preventDefault={() =>
            handlePeriodChange(graphIndicatorPeriodEnum.daily)}
    >
        Daily
    </p>
    <div class="divider divider-horizontal p-0" />
    <p
        class={`${defaultIndicatorClass} ${selectedPeriod === graphIndicatorPeriodEnum.weekly ? "bg-gray-200 font-bold" : ""}`}
        on:click|preventDefault={() =>
            handlePeriodChange(graphIndicatorPeriodEnum.weekly)}
    >
        Weekly
    </p>
    <div class="divider divider-horizontal p-0" />
    <p
        class={`${defaultIndicatorClass} ${selectedPeriod === graphIndicatorPeriodEnum.monthly ? "bg-gray-200 font-bold" : ""}`}
        on:click|preventDefault={() =>
            handlePeriodChange(graphIndicatorPeriodEnum.monthly)}
    >
        Monthly
    </p>
</div>

<style>
    .divider,
    .divider-horizontal {
        padding: 0;
        margin: 0;
        width: 0;
    }
</style>
